<template>
  <v-layout column>
    <v-layout v-if="loading == true" row style="width: 100%" pb-2 justify-end align-end>
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-layout>
    <v-layout v-if="loading == false" row style="width: 100%" pb-2 justify-end align-end>
      <v-flex px-2 shrink style="height: 36px;">
        <v-checkbox
          v-model="repeatTripDefinition.force"
          v-if="updateMode || alterMode"
          label="Reset & Force Trip Parameters"
        />
      </v-flex>
      <v-flex px-2 shrink style="height: 36px;">
        <v-checkbox
          v-model="repeatTripDefinition.recover"
          v-if="updateMode || alterMode"
          label="Recover Cancelled Trips"
        />
      </v-flex>
      <v-btn
        v-if="(!updateMode || updateMode == null) && (!alterMode || alterMode == null)"
        @click="create"
        class="text-none"
        small
      >Create Repeat Trip(s)</v-btn>
      <v-btn v-if="updateMode" @click="update" class="text-none" small>Update Trip(s)</v-btn>
      <v-btn
        v-if="repeatService.repeatServiceModel.trip_b == null && repeatService.repeatServiceModel.trip_a.id != null "
        @click="addReturnTrip"
        class="text-none"
        small
      >Add Return Trips</v-btn>
      <v-flex px-1 shrink>
        <v-btn v-if="alterMode" @click="cancel" class="text-none" small>Back</v-btn>
      </v-flex>
      <v-flex px-1 shrink>
        <v-btn v-if="alterMode" @click="alter" class="text-none" small>Alter Trip(s)</v-btn>
      </v-flex>
    </v-layout>
    <p style="color: red; margin-left: 18px;">{{bookingForm.errors.error}}</p>
  </v-layout>
</template>

<script>
import SimpleTextAreaInput from "@/components/widget/input/SimpleTextAreaInput.vue";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "RepeatTripOptions",
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    SimpleTextAreaInput
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    updateMode: {
      type: Boolean,
      default: false
    },
    alterMode: {
      type: Boolean,
      default: false
    },
    repeatService: Object,
    loading: Boolean,
    repeatTripDefinition: Object
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    cancel: function() {
      this.$emit("cancel", null);
    },
    alter: function() {
      this.$emit("alter", null);
    },
    create: function() {
      this.$emit("create", null);
    },
    update: function() {
      this.$emit("update", null);
    },
    addReturnTrip: function() {
      this.$emit("addReturnTrip", null);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
